import ConfigPath from './ConfigPath';

export default ConfigPath;
